import { IWorkItem } from "@wingspanhq/payments/dist/interfaces";

const INACTIVE_STATUS = "Inactive";

export function filterActiveWorkItems(workItems: IWorkItem[]): IWorkItem[] {
  return workItems.filter(item => (item as any).status !== INACTIVE_STATUS);
}
